<template>
  <div>
    <b-row>
      <b-col cols="12">
        <donation-export-form/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import DonationExportForm from "../../components/donation/DonationExportForm";
  export default {
    name: 'reports-donation',
    components: {
      DonationExportForm
    },
  }
</script>
